import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, } from 'reactstrap';
// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { getArticleMultiple } from '../../../../slices/thunks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';

import TimeTracking from './TaskDetails/TimeTracking';
import Summary from './TaskDetails/Summary';
import Comments from './TaskDetails/Comments';

const EvidenceForm = ({ dataActivity, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {

	const dispatch = useDispatch();

	const selectorArticle = createSelector(
		state => state.Article,
		data => ({
			dataList: data.articleList,
			isLoadingList: data.isLoadingList,
		})
	);

	const { dataList, isLoadingList, isAdding, isUpdating } = useSelector(selectorArticle);

	useEffect(() => {
		if (dataActivity && dataActivity.obligation && dataActivity.obligation.article) {
			dispatch(getArticleMultiple(dataActivity.obligation.article));
		}
	}, [dataActivity]);


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
		},

		validationSchema: Yup.object({
		}),
		onSubmit: values => {

		}
	});

	const columns = useMemo(
		() => [
			{ header: 'Normativa', accessorKey: 'normative.name',  size: 'auto', },
			{ header: 'Nro', accessorKey: 'normative.number',  size: 'auto', },
			{ header: 'Año', accessorKey: 'normative.year',  size: 'auto', },
			{ header: 'Artículo', accessorKey: 'article',  size: 'auto', },
			{ header: 'Sección', accessorKey: 'subsection',  size: 'auto' },
			{ header: 'Página', accessorKey: 'page',  size: 'auto' },
			{ header: 'Número', accessorKey: 'number',  size: 'auto' },
		],
		[]
	);


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row>
					<Col xxl={3}>
						<TimeTracking />
					</Col>
					<Col xxl={9}>
						<Summary />
						<Comments />
					</Col>
				</Row>

				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={6}>
								<Label for='title' className='form-label'>
									Nombre
								</Label>
								<Input
									name='title'
									id='title'
									className='form-control'
									value={dataActivity.title}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={6}>
								<Label for='summary' className='form-label'>
									Descripción
								</Label>
								<Input
									name='summary'
									id='summary'
									className='form-control'
									value={dataActivity.summary}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='activity_priority' className='form-label'>
									Prioridad
								</Label>
								<Input
									name='activity_priority'
									id='activity_priority'
									className='form-control'
									value={dataActivity.activity_priority.name}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='activity_type' className='form-label'>
									Tipo
								</Label>
								<Input
									name='activity_type'
									id='activity_type'
									className='form-control'
									value={dataActivity.activity_type.name}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='activity_group' className='form-label'>
									Grupo
								</Label>
								<Input
									name='activity_group'
									id='activity_group'
									className='form-control'
									value={dataActivity.activity_group.name}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='productive_cycle_stage' className='form-label'>
									Etapa
								</Label>
								<Input
									name='productive_cycle_stage'
									id='productive_cycle_stage'
									className='form-control'
									value={dataActivity.productive_cycle_stage.name}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={12}>
								<Label for='obligation' className='form-label'>
									Obligación
								</Label>
								<Input
									name='obligation'
									id='obligation'
									className='form-control'
									value={dataActivity.obligation.name}
									type='text'
									disabled
								/>
							</Col>

							<Col lg={12}>
								<Label for='article' className='form-label'>
									Lista de artículos
								</Label>
								<ODataGrid columns={columns} data={dataList || []} />
							</Col>

						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row className='g-3'>
							<Col lg={3}>
								<Label for='supervisory_entity' className='form-label'>
									Entidad Supervisora
								</Label>
								<Input
									name='supervisory_entity'
									id='supervisory_entity'
									className='form-control'
									value={dataActivity?.supervisory_entity?.name || ''}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='management' className='form-label'>
									Área Responsable
								</Label>
								<Input
									name='management'
									id='management'
									className='form-control'
									value={dataActivity?.management?.name || ''}
									type='text'
									disabled
								/>
							</Col>
							<Col lg={3}>
								<Label for='evidence_type' className='form-label'>
									Tipo de Evidencia
								</Label>
								<Input
									name='evidence_type'
									id='evidence_type'
									className='form-control'
									value={dataActivity?.evidence_type?.name || ''}
									type='text'
									disabled
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					{/* <button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className="label-icon"><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Establecimiento
					</button> */}
				</div>
			</div>
		</Form>
	);
};

export default EvidenceForm;
